import { ISSUE_ATTRIBUTE_NAMES } from '../constants/issue-attribute-names';
import { getUsersList } from './assigned-to-helpers';

export const getIsWorkflowMisconfigured = (transition, oxygen) => {
  const isWorkflowMisconfigured =
    transition &&
    transition.required_attributes &&
    transition.required_attributes.some((attributeName) => {
      const userTypeAttributes = [
        ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
        ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS,
        ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST,
      ];
      const isUserTypeAttribute = userTypeAttributes.includes(attributeName);
      if (!isUserTypeAttribute) {
        return false;
      }
      const assigneesArray = transition.values[attributeName];
      const permittedUsers = getUsersList(assigneesArray, oxygen);

      const attributeHasNoPermittedOptions = !(permittedUsers && permittedUsers.length);
      return attributeHasNoPermittedOptions;
    });

  return isWorkflowMisconfigured;
};
